import { PlaylistPlusIcon } from './PlaylistPlusIcon';

/**
 * author: Google
 * id 350D7B60-3F36-4FB0-9959-B90625F5267C
 * name playlist-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/playlist-plus.svg
 * tags
 */
export const PlaylistAddIcon = PlaylistPlusIcon;
export default PlaylistAddIcon